import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ExcursionServiceService } from '../service/excursion-service.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Router, NavigationEnd  } from '@angular/router';

@Component({
  selector: 'app-dashboardsetting',
  templateUrl: './dashboardsetting.component.html',
  styleUrls: ['./dashboardsetting.component.css']
})
export class DashboardsettingComponent implements OnInit {
  @ViewChild('ngSelect')
  ngSelect!: NgSelectComponent;
  reportlist:any=[]
  editing=false
  loading=true
  display_type=[{"id":1,"value":"All Booking"},{"id":2,"value":"No of Days"
}];
  dashboard_seeting=new FormGroup({
    usercode: new FormControl('', [Validators.required, Validators.minLength(3)]),
    view_limit:new FormControl('All Booking',Validators.required),
    is_new:new FormControl(1,Validators.required),
    noofdays:new FormControl('',Validators.required),
    
  });
  userlist:any=[]
  dashboardlist:any=[]

  constructor(private excursionServiceService:ExcursionServiceService,private router: Router) { }
  report_serarch_FormSubmit(){
this.excursionServiceService.dashboarsetting(this.dashboard_seeting.value).subscribe(res=>{
  ////console.log(res)
  this.loading=false
  if(res['result']==1){
    this.dashboardlist=res['data']
  }
})
  }
  ngOnInit(): void {
    this.loaduser()
    window.setTimeout(() => {
      // console.log('setting focus now');
      this.ngSelect.focus();
  }, 10);
    
    // this.display_type=[{"id":1,"value":'All Booking'},{"id":2,"value":'No of Days'}];
    
  }
  loaduser(){
    this.excursionServiceService.userlist().subscribe(res=>{
      
      if(res['result']==1){
        this.userlist=res['data']
        ////console.log(this.userlist)
        this.loaddashboard()

      }

    })
  }
  loaddashboard(){
    this.loading=false
    this.excursionServiceService.getdashboarsetting().subscribe(res=>{
      if(res['result']==1){
        this.dashboardlist=res['data']
      }
      
          })
  }
  onRowEditInit(product: any) {
    this.editing=true
    
}

onRowEditSave(product: any) {
  this.editing=false
   this.excursionServiceService.updatedashboarsetting(product).subscribe(res=>{
    if(res['result']==1){
      this.dashboardlist=res['data']
    }
   })
}

onRowEditCancel(product: any, index: any) {
    this.editing=false

}

ngAfterViewInit() {
  const cUrl = this.router.url;
  console.log(cUrl);
}

}
